import {
  ARENDE_ON_ADD_ARENDE,
  ARENDE_ON_GET_ARENDE,
  ARENDE_ON_START_GET_THIS_ARENDE,
  ARENDE_ON_GET_ARENDEN,
  ARENDE_ON_DELETE_ARENDE,
  ARENDE_ON_GET_ARENDEN_COUNT,
  ARENDE_ON_GET_ARENDEN_COUNT_ALL,
  ARENDE_ON_GET_FLODE,
  ARENDE_ON_START_GET_FLODE,
  ARENDE_ON_ERROR_GET_FLODE,
  ARENDE_ON_GET_ARTIKLAR,
  ARENDE_ON_GET_ARTIKLAR_COUNT,
  ARENDE_ON_GET_MEDARBETARE,

  ARENDE_ON_START_UPDATE_ARENDE,
  ARENDE_ON_UPDATE_ARENDE,
  ARENDE_ON_ERROR_UPDATE_ARENDE,
  SET_ARENDE_NUM_DOC,
  
  ARENDE_ON_ADD_ASSISTANSBÅT,
  ARENDE_ON_GET_ASSISTANSBÅTAR,
  ARENDE_ON_REMOVE_ASSISTANSBÅT,
  ARENDE_ON_FETCH_ASSISTANSBÅT,

  ARENDE_ON_GET_OLYCKSPLATS,

  ARENDE_ON_GET_INFO,
  ARENDE_ON_ADD_INFO,
  ARENDE_ON_DELETE_INFO,
  ARENDE_ON_UPDATE_INFO,
  ARENDE_ON_GET_EKONOMI,
  ARENDE_ON_ADD_EKONOMI,
  ARENDE_ON_DELETE_EKONOMI,
  ARENDE_ON_UPDATE_EKONOMI,
  ARENDE_ON_SEARCH_ARENDEN,
  ARENDE_ON_START_SEARCH_ARENDEN,
  ARENDE_ON_ERROR_SEARCH_ARENDEN,
  ARENDE_ON_START_GET_ARENDE,

  ARENDE_ON_START_POST_FLODE,
  ARENDE_ON_ERROR_POST_FLODE,
  ARENDE_ON_POST_FLODE,
  ON_GET_UTOKNING_BY_AFID,
  ON_START_GET_UTOKNING_BY_AFID,
  ARENDE_ON_START_GET_HISTORIK,
  ARENDE_ON_GET_HISTORIK,

  ARENDE_ON_START_GET_CASE_PDF_REPORT,
  ARENDE_ON_ERROR_GET_CASE_PDF_REPORT, 
  ARENDE_ON_GET_CASE_PDF_REPORT,

  ON_START_GET_ARANDE_KEDJA,ON_GET_ARANDE_KEDJA,ON_ERROR_GET_ARANDE_KEDJA,

  ON_GET_ARENDE_PAGE_BASIC,
	ON_GET_ARENDE_FILTER_BASIC,
  ARENDE_ON_START_GET_DOKUMENT,
  ARENDE_ON_GET_DOKUMENT,
  FETCH_START_SET_UNAUTHE,
  ON_GET_ORDER_ORGNR,ON_ERROR_GET_ORDER_ORGNR,ON_START_GET_ORDER_ORGNR,
  ON_START_MESSAGE_KUND,ON_MESSAGE_KUND,ON_ERROR_MESSAGE_KUND,

  ON_SAVE_ARENDE_CALC_ITEMS,
  ON_START_SAVE_ARENDE_CALC_ITEMS, 
  ON_ERROR_SAVE_ARENDE_CALC_ITEMS,
  ON_START_NEW_ARENDE_KALKYL_ID,
  ON_NEW_ARENDE_KALKYL_ID ,
  ON_ERROR_NEW_ARENDE_KALKYL_ID,
  ON_START_NEW_ARENDE_ABOKALKYL_ID ,
  ON_NEW_ARENDE_ABOKALKYL_ID ,
  ON_ERROR_NEW_ARENDE_ABOKALKYL_ID ,
  ON_START_GET_ARENDE_KALKYL_ID,
  ON_GET_ARENDE_KALKYL_ID ,
  ON_ERROR_GET_ARENDE_KALKYL_ID,
  ON_START_DELETE_ARENDE_KALKYL_RAD ,
  ON_DELETE_ARENDE_KALKYL_RAD ,
  ON_ERROR_DELETE_ARENDE_KALKYL_RAD ,
  ON_START_UPDATE_ARENDE_KALKYL_RAD,
  ON_UPDATE_ARENDE_KALKYL_RAD ,
  ON_ERROR_UPDATE_ARENDE_KALKYL_RAD ,

  ON_CLOSE_ARANDE_TOASTR,
  //JAck 
  ON_START_UPDATE_ARENDE_MESSAGE,ON_UPDATE_ARENDE_MESSAGE,ON_ERROR_UPDATE_ARENDE_MESSAGE,
}  from '../constants/ActionTypes'

import axios from 'util/Api' 
import { v4 as uuidv4 } from 'uuid';
import {history} from '../store'
import { isUndefined,isNull } from 'lodash';
import {RefreshUserInterface} from 'actions'
import fileSaver from 'file-saver' 
import { translate } from "../util/intlHelper";
import {encrypt,decrypt} from 'actions'

const getClientIp = async () => {
  let Ipadress='0.0.0.0'
  /**/  await fetch('http://ip-api.com/json')
    .then(response => response.json())
    .then(data => {console.log(data)
      Ipadress= data.query || "0.0.0.0"});
     
      return Ipadress
}

export const setArendePage = (Page) => {
  return (dispatch) => {
    dispatch({type: ON_GET_ARENDE_PAGE_BASIC, payload: {Page:Page}});
   }
}
export const setArendeFilter = (Filter) => {
  return (dispatch) => {
    dispatch({type: ON_GET_ARENDE_FILTER_BASIC, payload: {Filter:Filter}});
   }
}

export const addArende = (arende) => {
    return  async (dispatch) => {
      const ipAdress='0.0.0.0'
      const jwt =  JSON.parse(localStorage.token);

      const formData = new FormData()
      arende.files.forEach(file => formData.append('files[]', file));

      //formData.append('files[]', file);
      formData.append('Userid', arende.Userid);
      formData.append('AUserid', arende.AUserid);
      formData.append('HUserid', arende.HUserid);
      formData.append('Afid', arende.Afid);
      formData.append('Orgnr', arende.Orgnr);
      formData.append('Kund', arende.Kund);
      formData.append('Category', arende.Category);
      formData.append('Typ', arende.Typ);
      formData.append('TypId', arende.TypId);
      formData.append('Beskrivning', arende.Beskrivning);
      formData.append('Atgard', arende.Atgard);
      formData.append('KUserid',  arende.KUserid === '' ? 0 : arende.KUserid);
      formData.append('Prio', arende.Prio);
      formData.append('Prislista', arende.Prislista);
      formData.append('Medarbetare', JSON.stringify(arende.Medarbetare));
      formData.append('Kontakt', JSON.stringify(arende.Kontakt));
      formData.append('KontaktId', arende.KontaktId);
      formData.append('Taggar', JSON.stringify(arende.Taggar));
      formData.append('ipAdress', ipAdress);
      formData.append('status', arende.status);

      
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Creating.Errand")});
      axios.post('arende/add', formData, {body:{
        Userid: arende.Userid,
        AUserid: arende.Userid,
        HUserid: arende.HUserid,
        Afid: arende.Afid,
        Orgnr: arende.Orgnr,
        Kund: arende.Kund,
        Category: arende.Category,
        Typ: arende.Typ,
        Beskrivning: arende.Beskrivning,
        Atgard: arende.Atgard,
        KUserid: arende.KUserid === '' ? 0 : arende.KUserid,
        Prio: arende.Prio,
        Prislista: arende.Prislista,
        Medarbetare: arende.Medarbetare,
        Kontakt: arende.Kontakt,
        Taggar: arende.Taggar,
        status: arende.status,
        ipAdress: ipAdress,
      },headers: { 'Content-Type': 'multipart/form-data', 'Authorization':   `Bearer ${jwt}`}}).then(({data}) => {
				if(data.success){
					dispatch({type: ARENDE_ON_ADD_ARENDE, payload: data})
					dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.Create.Errand")})
					//dispatch(RefreshUserInterface(arende.Userid))
					dispatch(getArende(data.id, arende.Userid, undefined, arende.Afid))
				} else {
					dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Create.Errand")});
				}
      }).catch(err => {
        console.log(err)
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.Create.Errand")});
      })
    }
}
export const updateArende = (arende, Userid, Afid, nextActionCallback) => {
    return  async (dispatch) => {
      // console.log(arende)
     
      const jwt =  JSON.parse(localStorage.token);
      const ipAdress='0.0.0.0'
      dispatch({type: ARENDE_ON_START_UPDATE_ARENDE})
      axios.put('arende/update', {
        body: encrypt(JSON.stringify({
        id: arende.id,
        Typ: arende.Typ,
        TypId: arende.TypId,
        Category: arende.Category,
        Prio: arende.Prio,
        Beskrivning: arende.Beskrivning,
        Subject: arende.Subject,
        Kommentar: arende.Kommentar,
        Orgnr: arende.Orgnr,
        Kund: arende.Kund,
        Tele: arende.Tele,
        Atgard: arende.Atgard,
        Status: arende.status,
        AUserid: arende.AUserid,
        KUserid: arende.KUserid,
        KontaktId: arende.KontaktId,
        C_FName: arende.C_FName ?? '',
        C_LName: arende.C_LName ?? '',
        C_Email: arende.C_Email ?? '',
        C_Tele: arende.C_Tele ?? '',
        C_PersonNr: arende.C_PersonNr ?? '',
        HUserid: arende.HUserid,
        Medarbetare: arende.Medarr,
        PrisListId: arende.PrisListId,
        Prislista: arende.Prislista,
        ConversationRecipients: arende.ConversationRecipients,
        Freeflats: arende.Freeflats,
        ipAdress: ipAdress,
        Userid,
        Afid
      }))},{ 
      headers: { 'Authorization':   `Bearer ${jwt}`}})
      .then( data => {
        console.log("updateArende: ", data)
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateArende1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ARENDE_ON_UPDATE_ARENDE, payload: ndate.results}) 
          if(nextActionCallback){
            nextActionCallback()
          }

        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("updateArende2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ARENDE_ON_ERROR_UPDATE_ARENDE, payload: {message: translate("Error.Update.Errand")}})
        }
        //dispatch(RefreshUserInterface(Userid))
      }).catch(err => {
        dispatch({type: ARENDE_ON_ERROR_UPDATE_ARENDE, payload: {message: translate("Error.Update.Errand")}})
        console.log(err)
      })
    }
}

export const getArendeOrderById = (Afid,userid,Aid,page) =>{
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ORDER_ORGNR});
    axios.get('arende/order/get',
    { params:encrypt(JSON.stringify(
      {Afid:Afid,userid:userid,Aid:Aid,page:page,ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getArendeOrderById: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendeOrderById1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ORDER_ORGNR, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArendeOrderById2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ORDER_ORGNR, payload: ndate.error});
      }
      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ORDER_ORGNR, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

export const fetchAssistansBåtarInRange = (pos, Afid,userid, ObjectId) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ON_START_GET_UTOKNING_BY_AFID})
    axios.get('arende/getAssistansBatarInRange', 
    {params: encrypt(JSON.stringify(
      {lat: pos.lat, lng: pos.lng, Afid,ObjectId,ipAdress:ipAdress, Userid:userid}
    )),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("fetchAssistansBåtarInRange: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("fetchAssistansBåtarInRange1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_UTOKNING_BY_AFID, payload: ndate.results})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("fetchAssistansBåtarInRange2: ", endata);
        let ndate = JSON.parse(endata)
      }
      dispatch(RefreshUserInterface(userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteArende = (id, Afid, Offset, Filter, PageSize, Userid, SortObj,Filterstate) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('arende/delete', 
      { params:encrypt(JSON.stringify(
        {id, Userid, Afid,ipAdress:ipAdress}
      ))
        ,headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then( data => {
        //dispatch(RefreshUserInterface(Userid))
        console.log("deleteArende: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteArende1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_DELETE_ARENDE, payload: ndate})
        dispatch(getArenden(Afid, Offset, Filter, PageSize, SortObj, Userid, Filterstate))
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteArende2: ", endata);
        let ndate = JSON.parse(endata)
      }
      }).catch(err => {
      console.log(err)
    })
  }
}

export const getArenden = (Afid, Offset, Filter, PageSize, SortObj, Userid, Filterstate) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
  const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARENDE_ON_START_GET_ARENDE})
    axios.get('arende/get', {params: encrypt(JSON.stringify(
      {id: Afid, Offset, Filter, PageSize, SortObj,Userid,
      Filterstate,ipAdress:ipAdress }))
      ,headers: {
      'Authorization':   `Bearer ${jwt}`
  }}).then( data => {
    console.log("getArenden: ", data);
      if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getArenden1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ARENDE_ON_GET_ARENDEN, payload: {...ndate, SortObj}})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArenden2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const searchArenden = (Afid, Offset, Filter, PageSize, SearchString, SortObj, Userid, Filterstate) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'

		dispatch({type: ARENDE_ON_START_SEARCH_ARENDEN})
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/search', {params: encrypt(JSON.stringify(
      {Afid, Offset, Filter, PageSize, SearchString, SortObj, Userid, Filterstate,ipAdress:ipAdress } )),
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("searchArenden: ", data);
        if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("searchArenden1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ARENDE_ON_SEARCH_ARENDEN, payload: {...ndate, SortObj}})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("searchArenden2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      dispatch({type: ARENDE_ON_ERROR_SEARCH_ARENDEN})
      console.log(err)
    })
  }
}
export const getArendenByOrgnr = (Orgnr, Afid,userid, Offset,type,seachWord) => {
  type = isUndefined(type)?4:type
  seachWord = isUndefined(seachWord)?"":seachWord
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARENDE_ON_START_GET_ARENDE})
    dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.fetching.Errands")});
    axios.get('arende/getByOrgnr', {
      params: encrypt(JSON.stringify({Afid, Offset,userid, Orgnr,type,seachWord,ipAdress:ipAdress})),
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      dispatch(RefreshUserInterface(userid))
      console.log("getArendenByOrgnr: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)  
        console.log("getArendenByOrgnr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_ARENDEN, payload: ndate})
        dispatch({type: ON_MESSAGE_KUND,payload:translate("Action.fetch.Errands")});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArendenByOrgnr2: ", endata);
        dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Errands")});
      }
    }).catch(err => {
      console.log(err)
      dispatch({type: ON_ERROR_MESSAGE_KUND, payload: translate("Error.fetch.Errands")});
    })
  }
}

export const getArende = (id, Userid, fromUpdateSuccess, Afid,isFrom) => {
  isFrom=isUndefined(isFrom)?0:1
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    if(isFrom === 0){
    dispatch({type: ARENDE_ON_START_GET_THIS_ARENDE})
    }
    axios.get('arende/load', {params: encrypt(JSON.stringify(
      {id: id, Userid,ipAdress:ipAdress,Afid:Afid }
    )),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getArende: ", data);
    if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("getArende1: ", endata);
      let ndate = JSON.parse(endata)
      if(isFrom === 0){
          history.push(
            {
              pathname: '/app/ÄrendeKort',
              state: { 
                data: ndate,
                arende: ndate[0], 
                ekonomi: !isNull(ndate[1]) ? ndate[1]: {Upris: 0, Vpris: 0, Faktura:0},
                skadeplats: !isNull(ndate[2]) ? ndate[2]: {Båtid: "", Båtmodell: "", Båttillverkare: "", Forsakringsnr: "", Lat: 0, Lng: 0, Region: "", Skadeplats: ""},
                medarbetare: !isNull(ndate[3]) ? ndate[3]: []
              }
            }
          )
        }
          dispatch(RefreshUserInterface(Userid))
          dispatch({type: ARENDE_ON_GET_ARENDE, payload: ndate})
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getArende2: ", endata);
    }
      
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getArendeKedja = (id,Kuserid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.get('arende/Kload', {params: encrypt(JSON.stringify({id: id,Kuserid:Kuserid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getArendeKedja: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendeKedja1: ", endata);
        let ndate = JSON.parse(endata)
      history.push(
        {
          pathname: '/app/ÄrendeKort',
          state: { 
            data: ndate,
            arende: ndate[0], 
            ekonomi: !isNull(ndate[1]) ? ndate[1]: {Upris: 0, Vpris: 0, Faktura:0},
            skadeplats: !isNull(ndate[2]) ? ndate[2]: {Båtid: "", Båtmodell: "", Båttillverkare: "", Forsakringsnr: "", Lat: 0, Lng: 0, Region: "", Skadeplats: ""}
          }
        }
      )
      dispatch({type: ARENDE_ON_GET_ARENDE, payload: ndate})
      dispatch(RefreshUserInterface(Kuserid))
    }
    else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("getArendeKedja2: ", endata);
    }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getArendenCount = (Afid,userid, Filter) => {
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/count', {params: encrypt(JSON.stringify({ Afid, Filter,userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getArendenCount: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendenCount1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_ARENDEN_COUNT, payload: ndate})
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArendenCount2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getArendenCountOrgnr = (Afid,userid, Orgnr) => {
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/countOrgnr', {params: encrypt(JSON.stringify({ Afid, Orgnr,userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getArendenCountOrgnr: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendenCountOrgnr1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_ARENDEN_COUNT_ALL, payload: ndate})
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArendenCountOrgnr2: ", endata);
      }
      
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getFlode = (id, Userid, Afid) => {
  return  async (dispatch) => {
    
    dispatch({type: ARENDE_ON_START_GET_FLODE})
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/flode/get', {params: encrypt(JSON.stringify({ id,Userid,ipAdress:ipAdress,Afid:Afid })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      dispatch(RefreshUserInterface(Userid))
      console.log("getFlode: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getFlode1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_FLODE, payload: ndate})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getFlode2: ", endata);
        dispatch({type: ARENDE_ON_ERROR_GET_FLODE})
      }
      
    }).catch(err => {
      dispatch({type: ARENDE_ON_ERROR_GET_FLODE})
      console.log(err)
    })
  }
}
export const postMessage = (data, id, Userid,Afid, attachments) => {
  // console.log(data)
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    var formData = new FormData();

    if(attachments) {
      attachments.forEach(file => formData.append('files[]', file));
    }

    //formData.append('files[]', file);
    formData.append('Aid', data.Aid);
    formData.append('Message', data.Message);
    formData.append('ConversationRecipients', JSON.stringify(data.ConversationRecipients));
    formData.append('Subject', data.Subject??'');
    formData.append('MessageFromEmail', data.MessageFromEmail??'');
    formData.append('MessageType', data.MessageType??0);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('Uname', data.Uname);
    formData.append('ipAdress', ipAdress);
    

    dispatch({type: ARENDE_ON_START_POST_FLODE, payload: data})
    axios.post('arende/flode/post', 
      formData,
      {
      headers: { 
        'Content-Type': 'multipart/form-data',
        'Authorization':`Bearer ${jwt}`
      }
    }).then(({data}) => {
      //dispatch(RefreshUserInterface(Userid))
      dispatch(getFlode(id,Userid,Afid))
      dispatch({type: ARENDE_ON_POST_FLODE, payload: data.results})
      console.log(data)
    }).catch(err => {
      console.log(err)
      dispatch({type: ARENDE_ON_ERROR_POST_FLODE, payload: data})
    })
  }
}

export const updateMessage = (data, id, Aid, Userid,Afid) => {
  console.log(id)
  // console.log(data)
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_UPDATE_ARENDE_MESSAGE});
    const jwt =  JSON.parse(localStorage.token);
    axios.put('arende/flode/update', {body:encrypt(JSON.stringify({
      id,
      Message: data.Message,
      Date: data.Date, 
      ipAdress:ipAdress,
      Userid
    }))},
    { 
      headers: { 'Authorization':`Bearer ${jwt}`} })
      .then( data => {
        console.log("updateMessage: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateMessage1: ", endata);
        dispatch(getFlode(Aid,Userid,Afid))
        dispatch({type: ON_UPDATE_ARENDE_MESSAGE});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateMessage2: ", endata);
        dispatch(getFlode(Aid,Userid,Afid))
        dispatch({type: ON_ERROR_UPDATE_ARENDE_MESSAGE});
      }
    
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteMessage = (id, Aid, Userid, Afid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('arende/flode/delete', {params: encrypt(JSON.stringify({ id, Userid , ipAdress:ipAdress,})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("deleteMessage: ", data);
      //dispatch(RefreshUserInterface(Userid))
      dispatch(getFlode(Aid,Userid, Afid))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getAriklarArende = (id, Offset, Userid) => {
  console.log(Offset)
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/art/get', {params: encrypt(JSON.stringify({ id, Offset, Userid , ipAdress:ipAdress,})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getAriklarArende: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAriklarArende1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_ARTIKLAR, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAriklarArende2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const addArtikelArende = (data, id, Offset, Userid) => {
  console.log(data)
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.post('arende/art/post', { body:encrypt(JSON.stringify({
      Aid: data.Aid,
      Artid: data.Artid,
      Antal: data.Antal,
      Userid: Userid,
      ipAdress:ipAdress
    }))},
    {headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("addArtikelArende: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addArtikelArende1: ", endata);
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addArtikelArende2: ", endata);
      }
      //dispatch(RefreshUserInterface(Userid))
      dispatch(getAriklarArende(id, Offset, Userid))
      dispatch(getArendeArikelCount(id, Userid))
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeArtikelArende = (id, Aid, Offset,Userid) => {
  return  async (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    const ipAdress='0.0.0.0'
    axios.delete('arende/art/delete', {params: encrypt(JSON.stringify({ id,ipAdress:ipAdress,Userid })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("removeArtikelArende: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeArtikelArende1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeArtikelArende2: ", endata);
      }
      //dispatch(RefreshUserInterface(Userid))
      dispatch(getAriklarArende(Aid, Offset, Userid))
      dispatch(getArendeArikelCount(Aid, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getArendeArikelCount = (Aid, Userid) => {
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/art/count', {params: encrypt(JSON.stringify({ Aid, Userid ,ipAdress:ipAdress})), 
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getArendeArikelCount: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendeArikelCount1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_ARTIKLAR_COUNT, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)  
        console.log("getArendeArikelCount2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}


export const getMedarbetare = (Aid, Userid) => {
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/medarbetare/get', {params: encrypt(JSON.stringify({Aid,Userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getMedarbetare: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMedarbetare1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_MEDARBETARE, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMedarbetare2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const addMedarbetare = (Aid, Afid, Userid, MUserid) => {
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.post('arende/medarbetare/add', {body:encrypt(JSON.stringify({Aid, Afid, Userid, MUserid,ipAdress:ipAdress}))},
    {headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("addMedarbetare: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addMedarbetare1: ", endata);
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addMedarbetare2: ", endata);
      }
      dispatch(getMedarbetare(Aid, Userid))
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeMedarberate = (id, Aid, Userid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.delete('arende/medarbetare/delete', {params: encrypt(JSON.stringify({ id, Userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("removeMedarberate: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeMedarberate1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeMedarberate2: ", endata);
      }
      dispatch(getMedarbetare(Aid, Userid))
      //dispatch(RefreshUserInterface(Userid))
      console.log(data)
    }).catch(err => {
      console.log(err)
    })
  }
}

///SJÖASSISTANS
export const getAssistansBåtar = (Aid, Userid) => {
  console.log(Aid)
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    //dispatch(RefreshUserInterface(Userid))
    axios.get('arende/assistansbatar/get', {params: encrypt(JSON.stringify({Aid, Userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      let BåtIds = []
      let FaltIds = []
      dispatch(RefreshUserInterface(Userid))
      console.log("getAssistansBåtar: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAssistansBåtar1: ", endata);
        let ndate = JSON.parse(endata)

      dispatch({type: ARENDE_ON_GET_ASSISTANSBÅTAR, payload: ndate})
      ndate.map(async function (d) {
        if(!BåtIds.includes(d.Båtid))
          await BåtIds.push(d.Båtid)
        if(!FaltIds.includes(d.FaltId))
          await FaltIds.push(d.FaltId)
      })
      dispatch(fetchAssistansBåtar(BåtIds, Userid, FaltIds))
    }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAssistansBåtar2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const fetchAssistansBåtar = (BåtIds,userid, FaltIds = []) => {
  console.log(BåtIds)
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/assistansbatar/fetch', {params: encrypt(JSON.stringify({BåtIds,userid,ipAdress:ipAdress,FaltIds })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("fetchAssistansBåtar: ", data);
      if(data.data.success){  
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("fetchAssistansBåtar1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_FETCH_ASSISTANSBÅT, payload: ndate.results})
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("fetchAssistansBåtar2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const addAssistansBåt = (Aid, Afid, Userid, Båtid, Båtname, Arendenr, ObjektId, FaltId) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('arende/assistansbatar/add', {body:encrypt(JSON.stringify({Aid, Afid, Userid, Båtid, Båtname, Arendenr,ipAdress:ipAdress, ObjektId, FaltId}))
    },{headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("addAssistansBåt: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addAssistansBåt1: ", endata);        
        dispatch(getAssistansBåtar(Aid, Userid))
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addAssistansBåt2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const removeAssistansBåt = (id, Aid, Båtname, Båtid, Arendenr, Userid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('arende/assistansbatar/delete', {
      params: encrypt(JSON.stringify({ id, Aid, Båtname, Båtid, Arendenr,Userid,ipAdress:ipAdress })),
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("removeAssistansBåt: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeAssistansBåt1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeAssistansBåt2: ", endata);
      }
      dispatch(getAssistansBåtar(Aid, Userid))
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const markeraAssistansBåt = (Aid, id, Marked, Båtname, Userid) => {
  // console.log(Båtname)
  console.log(Userid)
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.put('arende/assistansbatar/mark', { body: encrypt(JSON.stringify({
      id,
      Marked,
      Aid,
      Båtname,
      Userid,
      ipAdress:ipAdress
    }))},{ 
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
        console.log("markeraAssistansBåt: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("markeraAssistansBåt1: ", endata);
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("markeraAssistansBåt2: ", endata);
      }
      dispatch(getAssistansBåtar(Aid, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const addOlycksplats = (Aid, Lat=0, Lng=0, Forsakringsnr = "", Skadeplats = "", Båtmodell = "", Båtid="", Båttillverkare="", Region="", Userid) => {
  console.log(Aid)
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('arende/olycksplats/add', { 
      method: 'POST',
      body:encrypt(JSON.stringify({Aid, Lat, Lng, Forsakringsnr, Skadeplats, Båtmodell, Båtid, Båttillverkare, Region, Userid,ipAdress:ipAdress}))
    },{
      headers: { 'Authorization':   `Bearer ${jwt}`}})
      .then( data => {
      console.log("addOlycksplats: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addOlycksplats1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addOlycksplats2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getOlycksplats = (Aid, Userid) => {
  // console.log(Aid)
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/olycksplats/load', {params: encrypt(JSON.stringify({Aid, Userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getOlycksplats: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getOlycksplats1: ", endata);
        let ndate = JSON.parse(endata)
        if(ndate.length === 0) {
          dispatch({type: ARENDE_ON_GET_OLYCKSPLATS, payload: null})
        }else{
          dispatch({type: ARENDE_ON_GET_OLYCKSPLATS, payload: ndate[0]})
        }        
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getOlycksplats2: ", endata);
        dispatch({type: ARENDE_ON_GET_OLYCKSPLATS, payload: null})
      } 
      dispatch(RefreshUserInterface(Userid))
     
    }).catch(err => {
      console.log(err)
    })
  }
}
///END - SJÖASSISTANS

export const getCInfo= (Aid,Userid) => {
  // console.log(Aid)
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/info/get', {params: encrypt(JSON.stringify({Aid,Userid ,ipAdress:ipAdress})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getCInfo: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv) 
        console.log("getCInfo1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_INFO, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getCInfo2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}


export const addCInfo = (Aid, Afid, Userid, Value1,Value2,Value3) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    
    axios.post('arende/info/add', {body:encrypt(JSON.stringify({Aid, Afid, Userid, Value1,Value2,Value3,ipAdress:ipAdress}))
    },{headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("addCInfo: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addCInfo1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addCInfo2: ", endata);
      }
      dispatch(getCInfo(Aid,Userid))
      //dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteCInfo = (id, Aid,Userid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('arende/info/delete', {params: encrypt(JSON.stringify({ id,Userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("deleteCInfo: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteCInfo1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteCInfo2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateCInfo = (Aid, id,userid, Value1,Value2,Value3) => {
  console.log(id)
  // console.log(data)
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.put('arende/info/update', { body:encrypt(JSON.stringify({
      id,
      Value1,
      Value2,
      Value3,
      userid,
      ipAdress:ipAdress
    }))},{ 
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      console.log("updateCInfo: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateCInfo1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateCInfo2: ", endata);
      }
      dispatch(getCInfo(Aid,userid))
    }).catch(err => {
      console.log(err)
    })
  }
}



export const getEkonomi= (Aid, Userid) => {
  // console.log(Aid)
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.get('arende/ekonomi/get', {params: encrypt(JSON.stringify({Aid,Userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getEkonomi: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEkonomi1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_EKONOMI, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEkonomi2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const getArendeHistorik= (Aid, Userid) => {
  // console.log(Aid)
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    dispatch({type: ARENDE_ON_START_GET_HISTORIK})
    axios.get('arende/historik/get', {params: encrypt(JSON.stringify({Aid,Userid,ipAdress:ipAdress})),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("getArendeHistorik: ", data);
      if(data.data.success){  
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendeHistorik1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_HISTORIK, payload: ndate})
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArendeHistorik2: ", endata);
      }
      dispatch(RefreshUserInterface(Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const addEkonomi = (Aid, Afid, Upris,Vpris,Faktura, Userid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.post('arende/ekonomi/add', {body: encrypt(JSON.stringify({Aid, Afid, Upris,Vpris,Faktura,Userid,ipAdress:ipAdress}))
    },{headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("addEkonomi: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addEkonomi1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addEkonomi2: ", endata);
      }
      dispatch(getEkonomi(Aid, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteEkonomi = (id,userid, Aid) => {
  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('arende/ekonomi/delete', {params: encrypt(JSON.stringify({ id,userid,ipAdress:ipAdress })),
    headers: { 'Authorization':`Bearer ${jwt}`}})
    .then( data => {
      console.log("deleteEkonomi: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteEkonomi1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteEkonomi2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const updateEkonomi = (Aid, id, Upris,Vpris,Faktura,Userid) => {
  console.log(id)
  // console.log(data)
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.put('arende/ekonomi/update', {body:encrypt(JSON.stringify({
      id,
      Upris,
      Vpris,
      Faktura,
      Userid,ipAdress:ipAdress
    }))},{ 
      headers: { 'Authorization':`Bearer ${jwt}`}})
      .then( data => {
      console.log("updateEkonomi: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateEkonomi1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateEkonomi2: ", endata);
      }
      dispatch(getEkonomi(Aid, Userid))
    }).catch(err => {
      console.log(err)
    })
  }
}

//getCasesByKedja
export const getCasesByKedja = ( Afid,userid, type,Page,searchWord) => {
  Page = (isUndefined(Page)?1:Page)
  searchWord = (isUndefined(searchWord)?"":searchWord)
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ON_START_GET_ARANDE_KEDJA});
    axios.get('kontos/arende/getByKedja',
    { params:encrypt(JSON.stringify({Afid:Afid,type:type,Page:Page,searchWord:searchWord,userid:userid,ipAdress:ipAdress})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getCasesByKedja: ", data);
      dispatch(RefreshUserInterface(userid))
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getCasesByKedja1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ARANDE_KEDJA, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getCasesByKedja2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ARANDE_KEDJA, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ARANDE_KEDJA, payload: error.message});
          if(!isUndefined(error.response.status)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const custom_script = (Afid,userid) => {
  // console.log(data)
  return async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    axios.put('arende/custom/script', encrypt(JSON.stringify({
      Afid,ipAdress:ipAdress,Userid:userid
    }))).then( data => {
      console.log("custom_script: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("custom_script1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("custom_script2: ", endata);
      }
    }).catch(err => {
      console.log(err)
    })
  }
}

export const AddDocByAid = (Aid, Userid, Document, Afid, Orgnr, page) => {

  console.log(Document, 'Document', Document.file)

  return  async (dispatch) => {
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);

    var formData = new FormData();
    Document.file.forEach(file => formData.append('files[]', file));

    //formData.append('files[]', file);
    formData.append('Aid', Aid);
    formData.append('Userid', Userid);
    formData.append('Afid', Afid);
    formData.append('Orgnr', Orgnr);
    formData.append('ipAdress', ipAdress);
    formData.append("name",Document.name)


    axios.post('arende/doc/add', 
    formData,
    {
      body: {
        Userid,
        Aid,
        Afid,
        Orgnr,
        name: Document.name,
        ipAdress:ipAdress
      },
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization':   `Bearer ${jwt}`
      }
    }
    ).then(({data}) => {
      console.log(data)
      //dispatch(RefreshUserInterface(Userid))
      dispatch({type: SET_ARENDE_NUM_DOC, payload: data})
      dispatch(GetDocByAid(Afid, Userid, Aid, (page - 1)))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const GetDocByAid = ( Afid, Userid, Aid, Offset) => {
  const jwt =  JSON.parse(localStorage.token);
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    dispatch({type: ARENDE_ON_START_GET_DOKUMENT})
    axios.get('arende/doc/get',
    { params:encrypt(JSON.stringify({ Userid, Aid, Offset,ipAdress:ipAdress, Afid})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("GetDocByAid: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("GetDocByAid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ARENDE_ON_GET_DOKUMENT, payload: ndate});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("GetDocByAid2: ", endata);
      }
     // console.log(data)
      dispatch(RefreshUserInterface(Userid))
     }).catch(function (error) {
       console.log(error)
     });
  }
}



export const RemoveDocById = (Userid,Afid, Aid,DocUrl, page, DocId, Mallmodulen = 0) => {
  return  async (dispatch) => {
    
    const ipAdress='0.0.0.0'
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('arende/doc/delete', { params:encrypt(JSON.stringify({DocId, Userid,Afid,DocUrl,ipAdress:ipAdress, Mallmodulen, Aid})),
    headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then(data => {
        console.log("RemoveDocById: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("RemoveDocById1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: SET_ARENDE_NUM_DOC, payload: ndate})
          dispatch(GetDocByAid(Afid, Userid, Aid, (page - 1)))
        } else {
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("RemoveDocById2: ", endata);
        }      
    }).catch(err => {
      console.log(err)
    })
  }
}
//updateThisDocArande
export const updateThisDocArande = (Afid,userid,updatedrad) => {
  return async (dispatch) => {
    const ipAdress='0.0.0.0'
    
    const jwt =  JSON.parse(localStorage.token);
    axios.put('arende/doc/update', 
    { params:encrypt(JSON.stringify(
      {
        Afid:Afid,
        userid:userid,
        updatedrad:updatedrad,
        ipAdress:ipAdress,
      }))
    },{ headers: {
      'Authorization':   `Bearer ${jwt}`
      }})
      .then( data => {
        console.log("updateThisDocArande: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateThisDocArande1: ", endata);
      } else {
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateThisDocArande2: ", endata);
      }
        //dispatch(RefreshUserInterface(userid))
      dispatch(GetDocByAid(Afid, userid, updatedrad.Aid, (updatedrad.page - 1)))
    }).catch(err => {
      console.log(err)
    })
  }
}


export const onSaveArendeCalcItems = (Aid, Orgnr, CalcItems, CalcItemsUpdatesArr) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_SAVE_ARENDE_CALC_ITEMS});
      axios.post('arende/onSaveArendeCalcItems', encrypt(JSON.stringify({
        Orgnr, CalcItems, CalcItemsUpdatesArr, Aid
      })), 
      {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
      }).then( data => {
        console.log("onSaveArendeCalcItems: ", data);
        if( data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("onSaveArendeCalcItems1: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_SAVE_ARENDE_CALC_ITEMS, payload: ndata.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("onSaveArendeCalcItems2: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_ERROR_SAVE_ARENDE_CALC_ITEMS, payload: ndata.error});
        }

      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_SAVE_ARENDE_CALC_ITEMS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }

export const saveNewNormalKalkylArende = (Afid,userid,Orderid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_NEW_ARENDE_KALKYL_ID});
      axios.put('arende/KalkylNormal/new', {
       body: encrypt(JSON.stringify({
         Afid:Afid,
         userid:userid,
         Aid:Orderid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl
       }))},{ 
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("saveNewNormalKalkylArende: ", data);
       if( data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("saveNewNormalKalkylArende1: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_NEW_ARENDE_KALKYL_ID, payload: ndata.results});
       }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("saveNewNormalKalkylArende2: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_ERROR_NEW_ARENDE_KALKYL_ID, payload: ndata.error});
       }
        
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_ARENDE_KALKYL_ID, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
 //saveNewAbonnemangKalkylOrder
 export const saveNewAbonnemangKalkylArende = (Afid,userid,Aid,Orgnr,nKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_NEW_ARENDE_ABOKALKYL_ID});
      axios.put('arende/KalkylAbonnemange/new', {
       body: encrypt(JSON.stringify({
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         Kalkyl:nKalkyl
       }))},{ 
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("saveNewAbonnemangKalkylArende: ", data);
       if( data.data.success) {
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("saveNewAbonnemangKalkylArende1: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_NEW_ARENDE_ABOKALKYL_ID, payload: ndata.results});
       }
       else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("saveNewAbonnemangKalkylArende2: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_ERROR_NEW_ARENDE_ABOKALKYL_ID, payload: ndata.error});
       }
      
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_NEW_ARENDE_ABOKALKYL_ID, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//getOrderKalkylById
export const getArendeKalkylById = (Orgrn,Afid,userid,Aid,ownProps) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
    dispatch({type: ON_START_GET_ARENDE_KALKYL_ID});
    axios.get('arende/getKalkylById',
    { params:encrypt(JSON.stringify({Orgnr:Orgrn,Afid:Afid,userid:userid,Aid:Aid})), 
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then( data => {
      console.log("getProjektKalkylById: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getArendeKalkylById1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_ARENDE_KALKYL_ID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getArendeKalkylById2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_ARENDE_KALKYL_ID, payload: ndate.error});
      }
     
      dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
       dispatch({type: ON_ERROR_GET_ARENDE_KALKYL_ID, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     }); /**/
  }
}

//deleteThisRowKalkylOrder
export const deleteThisRowKalkylArende = (Afid,userid,nrad) =>{
  const jwt = JSON.parse(localStorage.token);;
   return (dispatch) => {
     dispatch({type: ON_START_DELETE_ARENDE_KALKYL_RAD});
     axios.delete('arende/Kalkyl/delete', {
       method: 'DELETE',
       data: encrypt(JSON.stringify({
         rad:nrad,
         Afid:Afid,
         userid:userid
       })),
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
     console.log("deleteThisRowKalkylArende: ", data);
     if( data.data.success) {
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("deleteThisRowKalkylArende1: ", endata);
        let ndata = JSON.parse(endata)
        dispatch({type: ON_DELETE_ARENDE_KALKYL_RAD, payload: ndata.results});
     }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("deleteThisRowKalkylArende2: ", endata);
        let ndata = JSON.parse(endata)
        dispatch({type: ON_ERROR_DELETE_ARENDE_KALKYL_RAD, payload: ndata.error});
     }
  
     ////dispatch(RefreshUserInterface(userid))
   })
   .catch(function (error) {
     dispatch({type: ON_ERROR_DELETE_ARENDE_KALKYL_RAD, payload: error.message});
        if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
   });
   }
}
//UpdateNormalKalkylArende
export const UpdateNormalKalkylArende = (Afid,userid,Aid,Orgnr,Kalkyl,newKalkyl) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_UPDATE_ARENDE_KALKYL_RAD});
      axios.put('arende/Kalkyl/All/update', {
       body: encrypt(JSON.stringify({
         Afid:Afid,
         userid:userid,
         Aid:Aid,
         Orgnr:Orgnr,
         newKalkyl:newKalkyl,
         Kalkyl:Kalkyl
       }))},{ 
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateThisRowKalkylArende: ", data);
        if (data.data.success) {
         let endata = decrypt(data.data.encryptedData,data.data.iv)
         console.log("UpdateNormalKalkylArende1: ", endata);
         let ndata = JSON.parse(endata)
         dispatch({type: ON_UPDATE_ARENDE_KALKYL_RAD, payload: ndata.results});
        } else {
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("UpdateNormalKalkylArende2: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_ARENDE_KALKYL_RAD, payload: ndata.error});
        }
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_ARENDE_KALKYL_RAD, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
//updateThisRowKalkylOrder
export const updateThisRowKalkylArende = (Afid,userid,nrad) =>{
  const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_UPDATE_ARENDE_KALKYL_RAD});
      axios.put('arende/Kalkyl/update', {
       body: encrypt(JSON.stringify({
         Afid:Afid,
         userid:userid,
         nrad:nrad
       }))},{ 
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data => {
       console.log("updateThisRowKalkylArende: ", data);
       if (data.data.success) {
         let endata = decrypt(data.data.encryptedData,data.data.iv)
         console.log("updateThisRowKalkylArende1: ", endata);
         let ndata = JSON.parse(endata)
         //dispatch(RefreshUserInterface(userid))
         dispatch({type: ON_UPDATE_ARENDE_KALKYL_RAD, payload: ndata.results});
       } else {
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("updateThisRowKalkylArende2: ", endata);
          let ndata = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_ARENDE_KALKYL_RAD, payload: ndata.error});
        }
        
      ////dispatch(RefreshUserInterface(userid))
    }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_ARENDE_KALKYL_RAD, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
      });
    }
 }
	export const getArendePdfReport = (Aid, Arendenr, userid) => {
  const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
    const ipAdress='0.0.0.0'
    dispatch({type: ARENDE_ON_START_GET_CASE_PDF_REPORT});
    axios.get('arende/pdf-report',
    { params:{Aid}, 
      responseType: 'arraybuffer' ,
     headers: { 'Authorization': `Bearer ${jwt}`} }      
     ).then((resp) => {
				// console.log(resp.data, 'dataaaaaa')
				// const dirtyFileName = resp.headers['content-disposition'];
				// console.log(dirtyFileName)
				// const regex = /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/;
				// var  fileName = dirtyFileName.match(regex)[3];
   	    var blob = new Blob([resp.data], { type: 'application/pdf' });
        fileSaver.saveAs(blob, `Ärenderapport-${Arendenr}`);
       dispatch({type: ARENDE_ON_GET_CASE_PDF_REPORT});
	      dispatch(RefreshUserInterface(userid))
     }).catch(function (error) {
				console.log(error, 'errrororororor')
       dispatch({type: ARENDE_ON_ERROR_GET_CASE_PDF_REPORT, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
       } 
     }); /**/
  }
	}
 //onCloseArandeToaster
 export const onCloseArandeToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_CLOSE_ARANDE_TOASTR});
  }
}
